<template>
  <div id="app" :style="{ fontFamily: clientFont }">
    <topo></topo>
    <b-container id="corpo-site">
      <router-view></router-view>
    </b-container>
    <rodape></rodape>
  </div>
</template>

<script>
  import topo from './components/layout/topo.vue'
  import rodape from './components/layout/rodape.vue'
  import client from '@/main.js'

  export default {
    name: 'app',
    components: {
      topo,
      rodape
    },
    data() {
      return {
        client: null
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      document.title = client.clientData.name
    },
    computed: {
      clientFont() {
        return this.client === 'DOE-AL'
          ? 'HKGroteskPro, sans-serif !important'
          : 'Roboto, sans-serif !important'
      }
    }
  }
</script>

<style lang="scss">
  body {
    font-family: 'Roboto', sans-serif !important;
  }
  #corpo-site {
    min-height: 385px;
    padding-top: 25px;
    padding-bottom: 25px;
    .tituloPaginaRow {
      padding-left: 25px;
      padding-right: 25px;
      background-repeat: repeat-x;
    }
    .tituloPagina {
      padding-left: 10px;
      padding-right: 10px;
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      font-style: italic;
      background: white;
    }
    p {
      font-size: 15px;
      font-weight: 400;
      font-style: italic;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue